export const config = {
  formSelector: '.popup__form',
  inputSelector: '.popup__input',
  submitButtonSelector: '.popup__save',
  inactiveButtonClass: '.popup__save_inactive',
  inputError: '.popup__input_error',
  inputErrorClass: '.popup__input_type_error',
  errorClass: 'popup__error_visible',
};